<script setup lang="ts">
import ActiviteCommercialInfoCard from '@/components/activite-commercial/ActiviteCommercialInfoCard.vue'
import ClientsInfoCard from '@/components/clients/ClientsInfoCard.vue'
import KpiInfoCard from '@/components/kpi-chiffre-daffaires/KpiInfoCard.vue'
// import PerformanceFinanciere from '@/components/performance-financiere/PerformanceFinanciereInfoCard.vue'
import RepartitionFormationsInfoCard from '@/components/repartition-des-formations/RepartitionFormationsInfoCard.vue'
import SuiviCommandesInfoCard from '@/components/suivi-des-commandes/SuiviCommandesInfoCard.vue'
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import { markRaw } from 'vue'

const defaultComponents = [
  {
    id: 'kpi-chiffre-affaires',
    component: markRaw(KpiInfoCard),
    props: { column: 6 },
  },
//   {
//     id: 'performance-financiere',
//     component: markRaw(PerformanceFinanciere),
//     props: { column: 6 },
//   },
  {
    id: 'clients',
    component: markRaw(ClientsInfoCard),
    props: { column: 4 },
  },
  {
    id: 'suivi-des-commandes',
    component: markRaw(SuiviCommandesInfoCard),
    props: { column: 6 },
  },
  {
    id: 'activite-commerciale',
    component: markRaw(ActiviteCommercialInfoCard),
    props: { column: 4 },
  },
  {
    id: 'repartition-des-formations',
    component: markRaw(RepartitionFormationsInfoCard),
    props: { column: 6 },
  },
]

const { components } = useComponentOrder('tableau-de-bord-page', defaultComponents)
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
